import { getCompanyLogoUrl } from '../utils/cloudinary';

/**
 * Takes the path string from the JSON (e.g. "../../assets/company_logos/tesla_logo.png")
 * and returns the optimized Cloudinary URL.
 */
export const companyLogoToPicture = (logoPath: string): string => {
    if (!logoPath) return "";
    
    // Extract filename from path (e.g., "tesla_logo.png" from "../../assets/company_logos/tesla_logo.png")
    const filename = logoPath.split('/').pop() || "";
    
    // Remove extension to get the Cloudinary public ID
    const imageName = filename.replace(/\.(jpg|jpeg|png|webp|avif|svg|gif)$/i, '');
    
    if (!imageName) return "";
    
    return getCompanyLogoUrl(imageName);
};
